/**
 * OTC Exchange Page
 *
 * Exchanges a one-time code from query params for authentication tokens.
 * Shows loading state while exchanging, then redirects on success or shows error.
 */
import { useOtcExchange } from "@app/hooks/use-otc-exchange";
import { Skeleton } from "@its-engineering-and-development/ui-foundation/components";

export function OtcPage() {
    const { isLoading, isError, error } = useOtcExchange();

    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12">
            <div className="w-full max-w-md space-y-8 text-center">
                {isLoading && (
                    <>
                        <h1 className="text-2xl font-bold text-gray-900">Authenticating...</h1>
                        <p className="text-sm text-gray-600">Please wait while we verify your credentials.</p>
                        <div className="space-y-4">
                            <Skeleton className="h-4 w-full" />
                            <Skeleton className="mx-auto h-4 w-3/4" />
                        </div>
                    </>
                )}

                {isError && (
                    <>
                        <div className="flex justify-center">
                            <div className="rounded-full bg-red-100 p-4">
                                <svg className="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </div>
                        </div>
                        <h1 className="text-2xl font-bold text-gray-900">Authentication Failed</h1>
                        <p className="text-sm text-gray-600">{error?.message || "Unable to verify your credentials."}</p>
                        <a href="/" className="inline-block text-sm font-medium text-blue-600 hover:text-blue-800">
                            Return to Home
                        </a>
                    </>
                )}
            </div>
        </div>
    );
}

OtcPage.displayName = "OtcPage";
